import { useAllUsersFilterCountQuery } from 'requests/components/useAllUsersFilterQuery';
import { has } from 'lodash';

export function useFiltersCount(
  variables: Record<string, Record<string, unknown[] | Record<string, string>> | boolean>,
) {
  const userStringParams =
    has(variables, 'filtersQueryParams.user') && typeof variables.filtersQueryParams === 'object'
      ? new URLSearchParams(variables.filtersQueryParams.user as Record<string, string>).toString()
      : '';
  const [usersCount, isLoadingUserCount] = useAllUsersFilterCountQuery(!!variables.includeUser, userStringParams);

  const counts: Record<string, number> = {
    user: usersCount,
  };

  const allLoadings: Record<string, boolean> = {
    isLoadingUserCount,
  };

  const isToUpdate = Object.values(variables).some(Boolean) && Object.values(allLoadings).some((val) => val);

  if (isToUpdate) {
    Object.keys(counts).forEach((key) => {
      const keyWithInclude = key.replace(key.charAt(0), key.charAt(0).toUpperCase()).replace(/^/, 'include');
      if (!variables[keyWithInclude]) {
        delete counts[key];
      }
    });
  }
  return counts;
}
